import { render, staticRenderFns } from "./AddCorrespondent.vue?vue&type=template&id=7a39a01a&scoped=true&"
import script from "./AddCorrespondent.vue?vue&type=script&lang=js&"
export * from "./AddCorrespondent.vue?vue&type=script&lang=js&"
import style0 from "./AddCorrespondent.vue?vue&type=style&index=0&id=7a39a01a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39a01a",
  null
  
)

export default component.exports